module.exports = __webpack_public_path__ + "fonts/Quicksand-600-latin12.7b81366.woff2";